<template>
  <div class="page-wrapper">
    <div class="d-flex align-center pa-4">
      <h1 class="text-h6">
        {{ $t('patient_story') }}
      </h1>
      <v-spacer />
      <BasePrimaryActionButton
        :label="$t('create_patient_story')"
        :loading="savingPatientStory"
        :saving="savingPatientStory"
        @click="initPatientStory"
      />
    </div>

    <BaseTableLoader :loading="!patientStory">
      <PatientStoryTable
        :items="patientStory"
        :pagination="patientStoryPagination"
        :loading="loadingPatientStory"
        @edit="$router.push({ name: 'editPatientStory', params: { id: $event.id } })"
        @update:page="onPageChange"
        @delete="deletePatientStory"
        @click:image="viewImage"
        @click:text="viewDescription"
        @change:display="setStoryDisplayed"
      />
    </BaseTableLoader>
    <router-view @click:close="closeDialog" />
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import BaseTableLoader from '../../components/base/BaseTableLoader';
import BasePrimaryActionButton from '../../components/base/BasePrimaryActionButton';
import PatientStoryTable from '../../components/PatientStoryTable';

export default {
  name: 'PatientStory',

  components: { BaseTableLoader, BasePrimaryActionButton, PatientStoryTable },

  created() {
    if (!this.patientStory) {
      this.fetchPatientStory(this.$route.query);
    }
  },

  beforeRouteUpdate(to, from, next) {
    if (
      JSON.stringify(this.patientStoryFilterParams) !== JSON.stringify(to.query) &&
      to.name === 'patientStory'
    ) {
      this.fetchPatientStory(to.query);
    }
    next();
  },

  computed: mapState('patientStory', [
    'patientStory',
    'patientStoryPagination',
    'patientStoryFilterParams',
    'loadingPatientStory',
    'savingPatientStory',
  ]),

  methods: {
    ...mapActions('patientStory', [
      'fetchPatientStory',
      'storePatientStory',
      'updatePatientStory',
      'deletePatientStory',
    ]),

    initPatientStory() {
      this.storePatientStory().then((res) => {
        this.$router.push({ name: 'editPatientStory', params: { id: res.data.id } });
      });
    },

    onPageChange(page) {
      const query = { ...this.patientStoryFilterParams, page };
      this.$router.push({ name: 'patientStory', query });
    },

    viewImage(image) {
      this.$router.push({ name: 'patientStory/images', params: { url: image.image_path } });
    },

    viewDescription(event) {
      this.$router.push({
        name: 'patientStory/text',
        params: { id: event.id },
      });
    },

    setStoryDisplayed(event, story) {
      const editedStory = { ...story, show_in_homepage: event };
      this.updatePatientStory(editedStory);
    },

    closeDialog() {
      this.$router.push({ name: 'patientStory', query: this.patientStoryFilterParams });
    },
  },
};
</script>
